import React from 'react'
import Hero from '../../components/hero/Hero'
import PagesChecklist from '../../components/pages/PagesChecklist'
import './Desarrollo.css'
import ButtonMain from '../../components/ButtonMain'


function Desarrollo() {
    return (
        <div className="desarrolloWrapper">
            <Hero
            title="Desarrollo."
            title2="Construimos productos de app, web y software."
            sub="Desarrollamos proyectos de producto digital como aplicaciones móviles, páginas webs y software a medida."
         
            />
            <PagesChecklist
                subtitle="Productos que podemos crear a tu medida."
                checklist1="Páginas webs para startups y negócios."
                checklist2="Aplicaciones móviles públicas e industriales."
                checklist3="Software a medida  y  solucones de datos."
                checklist4="Ecosistemas cloud, data studios y hosting."
            />
            <div style={{height:"90px"}}/>
            <div className="desarrolloBtn">
            <ButtonMain mainbtn="¿Nos conectamos?"/>
            </div>
        </div>
    )
}

export default Desarrollo
